import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, TextField, Button, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminProductSubTypeForm = () => {
  const { id } = useParams(); // Düzenleme yapılacaksa id parametresi gelecek
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [productTypeId, setProductTypeId] = useState('');
  const [error, setError] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [productTypes, setProductTypes] = useState([]);

  useEffect(() => {
    // Ürün tiplerini dropdown için çekelim
    const fetchProductTypes = async () => {
      try {
        const response = await axiosInstance.get('/producttypes');
        setProductTypes(response.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchProductTypes();

    if (id) {
      setIsEdit(true);
      axiosInstance.get(`/productsubtypes/${id}`)
        .then(response => {
          setName(response.data.name);
          setDescription(response.data.description);
          setProductTypeId(response.data.productTypeId);
        })
        .catch(err => {
          console.error(err);
          setError('Ürün alttipi bilgileri alınamadı.');
        });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { name, description, productTypeId };
    try {
      if (isEdit) {
        await axiosInstance.put(`/productsubtypes/${id}`, data);
      } else {
        await axiosInstance.post(`/productsubtypes`, data);
      }
      navigate('/admin/productsubtypes');
    } catch (err) {
      console.error(err);
      setError('Bir hata oluştu.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          {isEdit ? 'Ürün Alttipini Düzenle' : 'Yeni Ürün Alttipi Ekle'}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Adı"
            fullWidth
            variant="outlined"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Açıklama"
            fullWidth
            variant="outlined"
            margin="normal"
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="product-type-label">Ürün Tipi</InputLabel>
            <Select
              labelId="product-type-label"
              label="Ürün Tipi"
              value={productTypeId}
              onChange={(e) => setProductTypeId(e.target.value)}
            >
              {productTypes.map(pt => (
                <MenuItem key={pt.id} value={pt.id}>
                  {pt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            {isEdit ? 'Güncelle' : 'Oluştur'}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default AdminProductSubTypeForm;
